export interface AnalyticsAdapter {
  identify(userId: string, traits?: Record<string, unknown>): void;
  track(event: string, props?: Record<string, unknown>): void;
  page(name: string, props?: Record<string, unknown>): void;
  reset(): void;
}

const noop: AnalyticsAdapter = {
  identify: () => undefined,
  track: () => undefined,
  page: () => undefined,
  reset: () => undefined,
};

let adapter: AnalyticsAdapter = noop;

/** Swap in PostHog or similar later without touching features. */
export function setAnalyticsAdapter(next: AnalyticsAdapter | null): void {
  adapter = next ?? noop;
}

export const analytics: AnalyticsAdapter = {
  identify: (...args) => adapter.identify(...args),
  track: (...args) => adapter.track(...args),
  page: (...args) => adapter.page(...args),
  reset: () => adapter.reset(),
};
